import angular from 'angular';
import Users from './users/users';
import Profiles from './profiles/profiles';
import UserDetails from './user-details/user-details';
import JobDetails from './job-details/job-details';
import Login from './login/login';
import Certificates from './certificates/certificates';
import Checks from './checks/checks';
import Media from './media/media';
import Survey from './survey/survey';
import Affiliates from './affiliates/affiliates';
import Vouches from './vouches/vouches';
import Analytics from './analytics/analytics';
import Jobs from './jobs/jobs';
import Flow from './flow/flow';
import BotFlow from './bot-flow/bot-flow';
import BotSessions from './bot-sessions/bot-sessions';
import BotSessionDetails from './bot-session-details/bot-session-details';
import BotManager from './bot-manager/bot-manager';
import AnalyticsRevenue from './analytics-revenue/analytics-revenue';
import AnalyticsUsers from './analytics-users/analytics-users';
import AnalyticsTraffic from './analytics-traffic/analytics-traffic';
import AnalyticsData from './analytics-data/analytics-data';
import AnalyticsBot from './analytics-bot/analytics-bot';
import AnalyticsMarketing from './analytics-marketing/analytics-marketing';
import Businesses from './businesses/businesses';
import BusinessDetails from './business-details/business-details';
import JobRequests from './job-requests/job-requests';
 
let ContainersModule = angular.module('app.containers', [
  Users.name,
  Profiles.name,
  UserDetails.name,
  JobDetails.name,
  Login.name,
  Certificates.name,
  Checks.name,
  Media.name,
  Survey.name,
  Affiliates.name,
  Vouches.name,
  Analytics.name,
  Jobs.name,
  Flow.name,
  BotFlow.name,
  BotSessions.name,
  BotManager.name,
  BotSessionDetails.name,
  AnalyticsRevenue.name,
  AnalyticsUsers.name,
  AnalyticsTraffic.name,
  AnalyticsData.name,
  AnalyticsBot.name,
  AnalyticsMarketing.name,
  Businesses.name,
  BusinessDetails.name,
  JobRequests.name,
]);
 
export default ContainersModule;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/containers.js
 **/